import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectPickBatches = (state) => get(state, 'pickBatches', emptyObject);

export const selectPickBatchById = (state, props) => get(selectPickBatches(state, props), props.pickBatchId);
